import { Controller } from "@hotwired/stimulus"

// Swaps the guidance under the details box to match the selected request type,
// so a dealer asking for a transfer is told to include the new owner's address
// rather than reading generic advice. Mirrors ChangeRequest::REQUEST_TYPES,
// which supplies the prompts.
export default class extends Controller {
  static targets = [ "type", "prompt" ];
  static values = { prompts: Object };

  declare readonly typeTarget: HTMLSelectElement;
  declare readonly promptTarget: HTMLElement;
  declare readonly promptsValue: Record<string, string>;

  connect() {
    this.update();
  }

  update() {
    const prompt = this.promptsValue[this.typeTarget.value];
    this.promptTarget.textContent = prompt ?? "";
    this.promptTarget.hidden = !prompt;
  }
}
